export default __webpack_public_path__ + "static/media/hot-mop-2.8362aa49.jpg";